<template>
  <div class="login-box">
    <a href="https://www.aidprint.com" class="site-home" target="_blank" rel="noopener noreferrer">{{words.siteHome}}</a>
    <div class="login-content">
      <div class="image-box">
        <p class="title">使用手机移动打印更方便</p>
        <div class="down">
          <p class="text">下载手机APP</p>
          <div class="qrcode">
            <img :src="AppCode" alt="" class="code">
          </div>
        </div>
        <img :src="background" alt class="bg">
      </div>
   

      <div class="login-box-from">
        <div class="set-pass-box-header">
            <div class="title">
              <p class="text">请设置密码</p>
              <p class="btns" @click="$lfy.Jump.Back()">跳过</p>
            </div>
             <p class="des">登录密码用于设备终端与电脑端登录</p>
        </div>
        <div class="from-box">
          <div class="item">
            <input type="text" placeholder="密码" class="input">
          </div>
          <div class="item">
            <input type="text" class="input" maxlength="6" placeholder="再次输入">
          </div>
          <div class="login-btn">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { mapGetters, mapActions } from "vuex";
import loginMenu from "../../components/login-mode";
export default {
  components: { loginMenu },
  data() {
    return {
      background: require("../../assets/login_bg.png"),
      closeBtn: require("../../assets/close.png"),
      Logo: require("../../assets/logo-black.png"),
      AppCode:require("../../assets/app_code.png"),
    };
  },
  mounted() {
    console.log(this.$route)
  },
  created(){
   
  },
  methods: {
    ...mapActions([])
  },
  computed: mapGetters({
    words: "words",
    user: "user"
  })
};
</script>



<style lang="scss" scoped>
@import "./index.scss";
</style>